import { useEffect, useState } from "react";

const seen = new Set();

// True hanya pada kemunculan pertama `key` selama sesi halaman ini.
// Dipakai agar gerak masuk tidak berulang saat kembali ke tab atau muat ulang daftar.
export function useFirstView(key) {
  const [first] = useState(() => !seen.has(key));
  useEffect(() => {
    seen.add(key);
  }, [key]);
  return first;
}
